import type { EntryType } from '../../../dtos/patientmr/charting';

/** Local (UI) entry type for each API entry type. Phase 18 adds RESPIRATORY, SEIZURE, OUTPUT and SUPERVISORY_NOTE. */
export const API_TO_LOCAL_ENTRY_TYPE: Record<EntryType, string> = {
  VITALS: 'vitals',
  MEDICATION: 'mar',
  GENERAL_NOTE: 'notes',
  WOUND_CARE: 'wound',
  INCIDENT: 'incident',
  MEASUREMENT: 'measurements',
  VISIT_SUMMARY: 'summary',
  FEED: 'feed',
  ADDENDUM: 'addendum',
  RESPIRATORY: 'respiratory',
  SEIZURE: 'seizure',
  OUTPUT: 'output',
  SUPERVISORY_NOTE: 'supervisory',
  THERAPY_TREATMENT: 'therapy',
  AIDE_TASKS: 'aidetasks',
  // Phase 20E: note templates use the API type in lower case
  PSYCHOSOCIAL_NOTE: 'psychosocial_note',
  RT_TREATMENT: 'rt_treatment',
  NUTRITION_NOTE: 'nutrition_note',
  BH_SESSION: 'bh_session',
  SYMPTOM: 'symptom',
};

const LOCAL_TO_API_ENTRY_TYPE: Record<string, EntryType> = Object.fromEntries(
  Object.entries(API_TO_LOCAL_ENTRY_TYPE).map(([api, local]) => [local, api as EntryType])
);

// Helper function to convert local entry type to API type
export const convertEntryTypeToApi = (localType: string): string =>
  LOCAL_TO_API_ENTRY_TYPE[localType] || localType.toUpperCase();

// Helper function to convert API entry type to local type
export const convertEntryTypeFromApi = (apiType: string): string =>
  (API_TO_LOCAL_ENTRY_TYPE as Record<string, string>)[apiType] || apiType.toLowerCase();
